<app-dialog [title]="data.group? ('action.edit-group' | translate): ('action.add-group' | translate)">

  <ng-container appDialogStickyHeader>
    @if (form) {
      <form [formGroup]="form">
        <div class="flex flex-v-center flex-gap8">
          <app-color-picker-input class="input-color flex1"
            [formControlName]="controls.COLOR">
          </app-color-picker-input>
          <mat-form-field class="flex1">
            <mat-label>{{ 'term.name' | translate }}</mat-label>
            <input matInput [formControlName]="controls.NAME">
            @if (form.controls[controls.NAME].errors?.required) {
              <mat-error>
                {{ 'message.error.required-field' | translate }}
              </mat-error>
            }
            @if (form.controls[controls.NAME].errors?.pattern) {
              <mat-error>
                {{ 'message.error.contains-illegal-symbols' | translate }}
              </mat-error>
            }
            @if (form.controls[controls.NAME].errors?.maxlength) {
              <mat-error
                >
                {{ 'message.error.max-length-symbols' | translate: {max: MAX_LENGTH_NAME_GROUP} }}
              </mat-error>
            }
            @if (form.controls[controls.NAME].errors?.nameIsUsed) {
              <mat-error>
                {{ 'message.error.name-already-exist' | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      </form>
    }
  </ng-container>

  <ng-container appDialogContent>
    <div class="unit-list">
      <app-unit-list-simple [units]="this.data?.allUnits ?? []"
        [selected]="this.data?.group?.units ?? []"
        (change)="selectedUnits = $event">
      </app-unit-list-simple>
    </div>
  </ng-container>


  <ng-container appDialogActions>

    <app-button-cancel></app-button-cancel>

    @if (data.group) {
      <app-button-delete (action)="onDelete()">
      </app-button-delete>
    }

    @if (!data.group) {
      <app-button-save (action)="onAddGroup()"
        [disabled]="!form.valid">
      </app-button-save>
    } @else {
      <app-button-save (action)="onSaveChanges()"
        [disabled]="!form.valid">
      </app-button-save>
    }
  </ng-container>
</app-dialog>
